import { StyleObject } from 'styletron-react';
import { KIND } from '.';
import { borderRadius, borderWidth } from '../../Utilities/utils/Theming';
import { focusRing } from '../../Themes/base/focusRing';
import { IDummyProps } from './types';

export const sliderRootStyles = (props: IDummyProps) => {
	return {
		style: () => {
			return {
				fontFamily: 'var(--epods--font-base)',
				paddingTop: 'var(--epods--space-inset-m)'
			};
		},
	};
};

export const sliderTrackStyles = () => {
	return {
		style: ({ $theme }: any) => {
			return {
				paddingBottom: $theme.slider.trackPaddingBottom,
			};
		},
	};
};

export const sliderInnerTrackStyles = (props: IDummyProps) => {
	const minP = props.min || 0;
	const maxP = props.max || 100;
	const percent0 = ((props.value[0] - minP) / (maxP - minP)) * 100;
	const percent1 = ((props.value[1] - minP) / (maxP - minP)) * 100;

	const thumbsNumber = props.value.length;

	return {
		style: ({ $theme }: any) => {
			const trackActiveBackground = props.disabled ? 'var(--epods--color-bg-primary-disabled)' : $theme.slider.trackActiveBackground;
			const trackBackground = props.disabled ? 'var(--epods--color-bg-inactive)' : $theme.slider.trackBackground;

			return {
				background:
					thumbsNumber > 1
						? `linear-gradient(to right, ${trackBackground} 0%, ${trackBackground} ${percent0}%, ${trackActiveBackground} ${percent0}%, ${trackActiveBackground} ${percent1}%, ${trackBackground} ${percent1}%, ${trackBackground} 100%)`
						: `linear-gradient(to right, ${trackActiveBackground} 0%, ${trackActiveBackground} ${percent0}%, ${trackBackground} ${percent0}%, ${trackBackground} 100%)`,
				height: $theme.slider.trackHeight,
			};
		},
	};
};

export const sliderThumbStyles = (props: IDummyProps) => {
	return {
		style: ({ $theme }: any) => {
			if (props.kind === 'circle') {
				return {
					height: $theme.slider.thumbCircleWidh,
					width: $theme.slider.thumbCircleHeight,
					display: 'flex' as any,
					alignItems: 'center',
					justifyContent: 'center',
					...borderRadius('50%'),
					...borderWidth('1px'),
					borderColor: 'var(--epods--color-border)',
					borderStyle: 'solid',
					textAlign: 'center' as 'center',
					backgroundColor: $theme.slider.thumbBackground,

					fontSize: 'var(--epods--font-size-p)',
					boxShadow: '0px 4px 8px rgba(94, 124, 143, 0.3)',
					':focus': props.disabled ? null : focusRing,
				} as StyleObject;
			}
			return {
				height: $theme.slider.thumbHeight,
				width: $theme.slider.thumbWidth,
				...borderRadius('2.5px'),
				...borderWidth('1px'),
				borderColor: 'var(--epods--color-border)',
				borderStyle: 'solid',
				backgroundColor: $theme.slider.thumbBackground,
				boxShadow: '0px 4px 8px rgba(94, 124, 143, 0.3)',
				':focus': props.disabled ? null : focusRing,
			} as StyleObject;
		},
	};
};

export const sliderInnerThumbStyles = (kind: KIND[keyof KIND] | undefined) => {
	return {
		style: ({ $theme }: any) => {
			if (kind === 'circle') {
				return {
					display: 'none' as any,
				};
			}
			return {
				width: $theme.slider.thumbTickWidth,
				height: $theme.slider.thumbTickHeight,
				position: 'absolute',
				top: '6px',
				backgroundColor: 'var(--epods--color-bluegrey-600)',
			};
		},
	};
};

export const sliderThumbValueStyles = (kind: KIND[keyof KIND] | undefined) => {
	return {
		style: ({ $theme }: any) => {
			if (kind === 'circle') {
				return {
					top: 'unset',
					fontFamily: "var(--epods--font-base)",
					color: 'var(--epods--color-grey-950)',
					outline: 'none',
					backgroundColor: 'none',
				};
			}
			return {
				fontFamily: "var(--epods--font-base)",
				color: "var(--epods--color-text-primary)",
				fontSize: "var(--epods--font-size-p)",
				lineHeight: "var(--epods--line-height-p)",
				top: $theme.slider.thumbValueTop,
				width: 'auto',
				height: $theme.slider.thumbTickHeight,
				outline: 'none',
				backgroundColor: 'none',
				paddingTop: 0,
				paddingRight: 0,
				paddingBottom: 0,
				paddingLeft: 0,
			};
		},
	};
};
